module.exports = __webpack_public_path__ + "img/login-bg.8b3bd105.jpg";